import React, { useState, useEffect } from 'react';
import { collection, query, orderBy, limit, onSnapshot } from 'firebase/firestore';
import { db } from '../config/firebase';
import Post from '../components/Post';
import { Flame } from 'lucide-react';

interface Post {
  id: string;
  content: string;
  author: {
    id: string;
    username: string;
    displayName: string;
  };
  likes: string[];
  comments: any[];
  createdAt: any;
  image?: string;
}

const Trending = () => {
  const [trendingPosts, setTrendingPosts] = useState<Post[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Create a query for top 10 posts with most likes
    const postsRef = collection(db, 'posts');
    const q = query(
      postsRef,
      orderBy('likes', 'desc'), // Order by number of likes in descending order
      orderBy('createdAt', 'desc'), // For posts with same likes, show newer first
      limit(10) // Limit to top 10 posts
    );

    // Subscribe to real-time updates
    const unsubscribe = onSnapshot(q, (snapshot) => {
      const posts = snapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      })) as Post[];

      setTrendingPosts(posts);
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  return (
    <div>
      <div className="border-b border-gray-800 sticky top-0 bg-gray-900/80 backdrop-blur-sm z-10">
        <div className="p-4 flex items-center space-x-3">
          <Flame className="w-6 h-6 text-orange-500" />
          <h1 className="text-xl font-bold">Trending</h1>
        </div>
      </div>

      {loading ? (
        <div className="flex justify-center items-center h-64">
          <div className="animate-spin rounded-full h-8 w-8 border-2 border-purple-500 border-t-transparent"></div>
        </div>
      ) : trendingPosts.length === 0 ? (
        <div className="text-center py-8 text-gray-500">
          <p className="text-lg">No trending posts yet</p>
          <p className="text-sm">Posts with the most likes will appear here</p>
        </div>
      ) : (
        <div>
          {trendingPosts.map((post, index) => (
            <div key={post.id} className="relative">
              {/* Trending Rank */}
              <div className="absolute top-4 right-4 bg-gray-900/80 backdrop-blur-sm rounded-full w-8 h-8 flex items-center justify-center text-orange-500 font-bold">
                #{index + 1}
              </div>
              <Post post={post} />
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Trending;